import { Router } from "@frui.ts/screens/dist";
import { Modules } from "config";
import type Role from "entities/role";
import RoleRepository from "repositories/roleRepository";
import LocalizationService from "services/localizationService";
import EventBus from "services/eventBus";
import ConfirmationService from "services/confirmationService";
import NotificationService from "services/notificationService";
import ListViewModel from "viewModels/listViewModel";
import SecurityService from "../../../services/securityService";
import RoleCreateViewModel from "./roleCreateViewModel";
import RoleDetailViewModel from "./detail/roleDetailViewModel";

const navigationName = "roles";

@Router.registerRoute({ route: navigationName, name: Router.Self, children: [RoleCreateViewModel, RoleDetailViewModel] })
export default class RoleViewModel extends ListViewModel<Role, RoleDetailViewModel, RoleCreateViewModel> {
  readonly modelName = "role";

  constructor(
    protected createViewModelFactory: () => RoleCreateViewModel,
    protected detailViewModelFactory: ReturnType<typeof RoleDetailViewModel.Factory>,
    protected repository: RoleRepository,
    protected localizationService: LocalizationService,
    protected eventBus: EventBus,
    protected confirmationService: ConfirmationService,
    protected notificationService: NotificationService,
    protected securityService: SecurityService
  ) {
    super();
    this.navigationName = navigationName;
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.users, `role.${code}`, size);
  }
}
